import { faqArticleBodySchema } from "@redotech/redo-support-common/faq/faq-body-schema";
import { faqElementSchema } from "@redotech/redo-support-common/faq/faq-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateArticle = {
  name: "updateArticle" as const,
  input: z.object({
    elements: z.array(faqElementSchema).optional(),
    html: z.string().optional(),
    title: z.string(),
    faqCollection: z.string(),
    published: z.boolean(),
    id: z.string(),
  }),
  output: zExt.coercedResult(
    z.object({
      oldArticle: faqArticleBodySchema,
      newArticle: faqArticleBodySchema,
    }),
  ),
};
